// import TextField from '@components/text-field/text-field';
import { Box, Chip, Grid, TextField, Typography } from "@mzc-pdc/ui";
import React, { useCallback, useMemo, useRef, useState } from "react";
import { getProjectUsersAPI } from "@modules/apis/user-management-v2";
import { useSelector } from "react-redux";
import { AutocompleteUsers } from "@components_v2/autocomplete";
import { useEffect } from "react";
import { StyledAutocompletePopper } from "@features/chip-popper-components/chip-types-input/chip-types-input.styled";
import { useTranslation } from "react-i18next";
import { ImageEmptySearchMini, ImageSearch } from "@mzc-cloudplex/icons";
import theme from "@styles/theme";
import { SPACE_SCOPE } from "@constants";
import { getUsersAPI } from "@modules/apis/user-management-v2";
import { siteMode } from "@cores/siteMode";

export const ChipUsersInputV2 = ({
    user,
    disabled = false,
    onDeleteUser,
    onAddUser,
    placeholder = undefined,
    isEdit,
    scope,
    isPopperComponent = false,
}) => {
    const { t } = useTranslation();
    const space = useSelector(({ stage }) => stage);
    const project = useSelector(({ project }) => project);
    const [open, setOpen] = useState(false);

    const [checkSearch, setCheckSearch] = useState(false); // Note : noOptionsText에서 검색 여부에 따라 내용이 달라져서 검색을 했는지 체크하기 위해 추가했습니다.
    const [value, setValue] = useState(user);
    const [searchedValue, setSearchedValue] = useState(""); //현재 검색중인 이름
    const [userOptions, setUserOptions] = useState([]);
    const [pendingUser, setPendingUser] = useState(false);
    const userPage = useRef(0);
    const totalUser = useRef(-1);
    const USER_LIMIT = 40;

    const getUserList = useCallback(
        async (isInitValue = false) => {
            try {
                if (pendingUser || totalUser.current === userOptions?.length || !value) return;
                setPendingUser(true);
                if (scope === SPACE_SCOPE.PROJECT) {
                    const response = await getProjectUsersAPI(space.id, space.endpoint, project.id, {
                        name: value,
                        siteAccess: "CONSOLE",
                        shouldRequestDetail: false,
                        limit: USER_LIMIT,
                    });
                    // console.log(userOptions);
                    if (isInitValue) {
                        setUserOptions([...response.data.results]);
                        setCheckSearch(true);
                    } else setUserOptions([...userOptions, ...response.data.results]);
                    userPage.current += 1;
                    totalUser.current = response.data.totalCount;
                }
                if (scope === SPACE_SCOPE.ADMIN) {
                    const response = await getUsersAPI(space.id, space.endpoint, null, {
                        name: value,
                        limit: USER_LIMIT,
                    });
                    if (isInitValue) {
                        setUserOptions([...response.data.results]);
                        setCheckSearch(true);
                    } else setUserOptions([...userOptions, ...response.data.results]);
                    userPage.current += 1;
                    totalUser.current = response.data.totalCount;
                }
            } catch (error) {
                console.error(error);
            } finally {
                setPendingUser(false);
            }
        },
        [pendingUser, space, value, searchedValue, userOptions, project],
    );

    const onHandleDeleteUser = useCallback(
        (index) => {
            onDeleteUser();
            setSearchedValue("");
            setCheckSearch(false);
        },
        [onDeleteUser],
    );

    const onHandleClickOption = useCallback(
        (selected) => {
            if (selected) {
                const foundUser = userOptions.find((user) => user.id === selected.id);
                setValue(foundUser);
                onAddUser({ id: foundUser?.id, name: foundUser?.name });
                setCheckSearch(false);
            } else {
                onDeleteUser();
            }
        },
        [userOptions, onAddUser],
    );

    const handleInputChange = (reason) => {
        if (reason === "clear") {
            // setSelectedUser(null);
            setValue(null);
        }
    };

    function PopperComponent(props) {
        const { disablePortal, anchorEl, open, ...other } = props;
        return <StyledAutocompletePopper {...other}></StyledAutocompletePopper>;
    }

    useEffect(() => {
        getUserList(true); //최초 조회
        if (user?.id) setValue(user);
    }, []);

    return (
        <AutocompleteUsers
            value={value?.id ? value : null}
            open={isPopperComponent ? true : open}
            setOpen={setOpen}
            disabled={disabled}
            setValue={setValue}
            isEdit={isEdit}
            placeholder={placeholder}
            options={userOptions.map((user) => ({ name: user.name, id: user.id, email: user.email }))}
            checkDuplicateValue={false}
            onInputChange={handleInputChange}
            onDelete={onHandleDeleteUser}
            // onScroll={onHandleScrollUser} //TODO: 무한스크롤로 구현
            onClickOption={onHandleClickOption}
            PopperComponent={isPopperComponent ? PopperComponent : undefined}
            ListboxProps={isPopperComponent ? { sx: { maxHeight: "none" } } : undefined}
            isAvatarIconRequired={true}
            noOptionsText={
                !pendingUser && (
                    <Grid
                        container
                        justifyContent={"center"}
                        alignItems={`center`}
                        flexDirection={"column"}
                        sx={{ height: "97px" }}
                    >
                        {checkSearch ? (
                            <>
                                <ImageEmptySearchMini width={24} height={24} />
                                <Typography component={"span"} color={theme.palette.secondary[800]}>
                                    {t(`common::msg::No search results found.`)}
                                </Typography>
                            </>
                        ) : (
                            <>
                                <ImageSearch width={24} height={24} />
                                <Typography component={"span"} color={theme.palette.secondary[800]}>
                                    {t(`common::msg::Search for the owner of the asset.`)}
                                </Typography>
                            </>
                        )}
                    </Grid>
                )
            }
            handleClose={() => setOpen(false)}
            sx={{
                ".MuiAutocomplete-endAdornment": { visibility: isPopperComponent ? "hidden" : "visible" },
            }}
        ></AutocompleteUsers>
    );
};
